module.exports = __webpack_public_path__ + "assets/img/test.98d6cdb4.gif";